import { ROUTE_DASHBOARD, ROUTE_SIGN_IN, ROUTE_SIGN_IN_ENTER_EMAIL } from '@/constants/routes';
import authService from '@/services/auth.service';
import { hasWorkosSession } from '@/services/workos-auth-bridge';
import { Navigate, RouteObject, redirect } from 'react-router-dom';
import { routeEnterEmail } from './components/enter-email/enter-email.route';
import { routeVerifyOTP } from './components/verify-otp/verify-otp.route';
import Page from './sign-in.page';

export const routeSignIn: RouteObject = {
  path: ROUTE_SIGN_IN,
  loader() {
    if (authService.isLoggedIn() || hasWorkosSession()) {
      return redirect(ROUTE_DASHBOARD);
    }
    return null;
  },
  Component: Page,
  children: [
    { index: true, element: <Navigate to={ROUTE_SIGN_IN_ENTER_EMAIL} replace /> },
    routeEnterEmail,
    routeVerifyOTP,
  ],
};
